/* eslint-disable @typescript-eslint/no-explicit-any */
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import AddNotification from "../components/AddNotification";
import { postNotification } from "../../../actions/AdminActions";
import { getListResult } from "../../../utils";

const mapStateToProps = ({
  notificationsState,
  notificationTypeState,
  loggedInUserState,
}: ApplicationState) => ({
  notificationsState: notificationsState.response,
  notificationType: getListResult(notificationTypeState.response),
  loggedInUserState: loggedInUserState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    postNotification: (payload: FormData) => {
      dispatch(postNotification(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNotification);
